import axios from "@/axios/axios";
import qs from "qs";

export default {
  namespaced: true,
  actions: {
    requestProductByKeyword(context, payload) {
      return axios
        .post("/api/product/getList", null, {
          params: {
            searchText: payload.searchText,
            currentPage: payload.currentPage,
            perPage: payload.perPage,
            sortBy: payload.sortBy,
            sortDesc: payload.sortDesc,
            categories: "",
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    requestCorpProductByKeyword(context, payload) {
      return axios
        .post("/api/corp/product/getList", null, {
          params: {
            searchText: payload.searchText,
            currentPage: payload.currentPage,
            perPage: payload.perPage,
            sortBy: payload.sortBy,
            sortDesc: payload.sortDesc,
            status: payload.status,
            categories: "",
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    requestCorpProductByCategoryNameList(context, payload) {
      return axios
        .post("/api/corp/product/getList", null, {
          params: {
            searchText: "",
            currentPage: payload.currentPage,
            perPage: payload.perPage,
            sortBy: payload.sortBy,
            sortDesc: payload.sortDesc,
            status: "",
            categories: payload.categoryNameList,
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    requestProductDetail(context, payload) {
      return axios
        .post("/api/product/getDetail", null, {
          params: {
            idx: payload.idx,
            status: payload.status,
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    saveProduct(context, payload) {
      const formData = new FormData();
      formData.append("idx", payload.idx);
      formData.append("categoryList", JSON.stringify(payload.categoryList));
      formData.append("manufacture", payload.manufacture);
      formData.append("file0", payload.file0);
      formData.append("file1", payload.file1);
      formData.append("file2", payload.file2);
      formData.append("file3", payload.file3);
      formData.append("file4", payload.file4);
      formData.append("file5", payload.file5);
      formData.append("name", payload.name);
      formData.append("company", payload.company);
      formData.append("price", payload.price);
      formData.append("homepage", payload.homepage);
      formData.append("desc", payload.desc);
      formData.append("detail", payload.detail);
      formData.append(
        "additionalItemDataList",
        JSON.stringify(payload.additionalItemDataList)
      );
      formData.append("deleteFileList", JSON.stringify(payload.deleteFileList));

      return axios
        .post("/api/corp/product/save", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    requestCorpProductDetail(context, idx) {
      return axios
        .post("/api/corp/product/getDetail", null, {
          params: {
            idx: idx,
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    deleteProduct(context, idxList) {
      return axios
        .get("/api/corp/product/delete", {
          params: {
            idxList: idxList,
          },
          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    requestProductBySubCategory(context, payload) {
      return axios
        .post("/api/product/getList/bySubCategory", null, {
          params: {
            currentPage: payload.currentPage,
            perPage: payload.perPage,
            sortBy: payload.sortBy,
            sortDesc: payload.sortDesc,
            status: payload.status,
            categories: payload.categories,
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
  },
};
